import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import { Props } from "./interfaces";

const CustomDropdown = ({
  sxProps,
  variant,
  label,
  field,
  defaultValueID,
  value,
  values,
  handleChange,
  required,
  smallerInputStyles = false,
  disabled = false,
  customOptionLabel,
}: Props) => {
  return (
    <FormControl
      disabled={disabled}
      variant={variant}
      sx={{
        width: "100%",
        ...(smallerInputStyles && { width: "320px" }),
        ...(sxProps && sxProps),
      }}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        required={required}
        value={
          values &&
          values.find((val) =>
            // if there is value, we check for value selected
            value ? val.id === value.id : defaultValueID
          )
        }
        onChange={(e) => {
          if (field && handleChange) {
            e.stopPropagation();
            handleChange(field, e.target.value);
          }

          return;
        }}
        label={label}
        sx={{
          ...(smallerInputStyles && {
            "& > .MuiSelect-select": {
              padding: "22px 14px 8px",
            },
          }),
        }}
      >
        {values?.map((value: any) => (
          <MenuItem
            value={value}
            key={value.id}
          >
            {customOptionLabel ? value[customOptionLabel] : value.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomDropdown;
